<template>
  <div class="i-report-checkout">
    <div class="logo-bar">
      <img
        class="logo"
        loading="lazy"
        alt="Jobtest Logo"
        :src="logoDark"
      />
    </div>
    <div class="content">
      <span
        class="back"
        @click="goToPaywall"
      >
        <img
          class="chevron"
          :src="iconChevron"
        />Back</span
      >
      <div class="intro">
        Take a shortcut to the most fulfilling & <span>profitable</span> years of your career.
        <div class="sub">Invest in yourself & enjoy lifelong career success.</div>
      </div>
      <div class="points">
        <div class="point">
          <img :src="iconSecure" />
          <div class="text">
            Secure <span>{{ isTabletOrLarger ? "End - to - end encryption" : "Encrypted" }}</span>
          </div>
        </div>
        <div class="point">
          <img :src="iconGuarantee" />
          <div class="text">
            Guarantee <span>{{ isTabletOrLarger ? "30-day money back" : "30-day refund" }}</span>
          </div>
        </div>
        <div class="point">
          <img :src="iconSupport" />
          <div class="text">
            {{ isTabletOrLarger ? "24/7 " : "" }}Support<span>{{
              isTabletOrLarger ? "Any issues resolved" : "24/7 chat"
            }}</span>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="left">
          <div class="card plan">
            <div class="title">
              {{ PLANS[stripePrice].type }} plan
              <span>Cancel anytime. No commitment.</span>
            </div>
            <div class="price">
              <div class="total">
                <span>{{ PLANS[stripePrice].price }}</span>
                <span class="timeline">/ month</span>
              </div>
              <div class="day">
                Just <strong>{{ PLANS[stripePrice].perDay }}</strong> a day
              </div>
              <div class="grey">{{ PLANS[stripePrice].price }} billed {{ PLANS[stripePrice].timeline }}</div>
            </div>
            <div class="perks">
              <div class="lil-header">Includes</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Your top 10 career matches</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Personality breakdown & deep insights</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Tailored career strategy</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Resume & LinkedIn Optimization</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Unlimited quiz retakes</div>
              <div class="item"><img :src="PLANS[stripePrice].icon" />Weekly live career coaching</div>
            </div>
          </div>

          <div
            v-if="isDesktopOrLarger"
            class="card next"
          >
            <div class="lil-header">What happens next</div>
            <div class="tips">
              <div class="tip">
                <div class="number">1</div>
                <div class="do">
                  Pay securely
                  <div class="explain">One-click checkout — encrypted, processed by Stripe.</div>
                </div>
              </div>
              <div class="tip">
                <div class="number">2</div>
                <div class="do">
                  Dashboard unlocks instantly
                  <div class="explain">Your top 10 matches, personality breakdown, and 90-day plan are waiting.</div>
                </div>
              </div>
              <div class="tip">
                <div class="number">3</div>
                <div class="do">
                  Start exploring
                  <div class="explain">Unlimited retakes, weekly group coaching, and live job alerts are all on.</div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="isDesktopOrLarger"
            class="card reviewers"
          >
            <div class="lil-header">From people like you</div>
            <div class="reviews">
              <div class="review">
                <img
                  class="star"
                  :src="ImageStars"
                />
                <div class="comment">
                  “Zanetta helped me get a much higher paying job. She was especially helpful with focusing on what I
                  should pursue and the job interview process. Well worth the money.”
                </div>
                <div class="who">
                  Jaxson
                  <div class="verified">. Verified</div>
                </div>
              </div>
              <div class="review">
                <img
                  class="star"
                  :src="ImageStars"
                />
                <div class="comment">
                  “When I got pregnant, I quit my job and took care of my son for the past 20 years. Now that my son is
                  off to college, I wanted to return to the workforce but didn’t know what to do…”
                </div>
                <div class="who">
                  Hyunmi L.
                  <div class="verified">. Verified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div id="embedded-form">
            <iStripeEmbeddedForm
              :stripe-price="stripePrice"
              :user-flow="UserFlow.REPORT"
              @error="onStripeError"
            />
          </div>
        </div>
        <div
          v-if="!isDesktopOrLarger"
          class="small"
        >
          <div class="card next">
            <div class="lil-header">What happens next</div>
            <div class="tips">
              <div class="tip">
                <div class="number">1</div>
                <div class="do">
                  Pay securely
                  <div class="explain">One-click checkout — encrypted, processed by Stripe.</div>
                </div>
              </div>
              <div class="tip">
                <div class="number">2</div>
                <div class="do">
                  Dashboard unlocks instantly
                  <div class="explain">Your top 10 matches, personality breakdown, and 90-day plan are waiting.</div>
                </div>
              </div>
              <div class="tip">
                <div class="number">3</div>
                <div class="do">
                  Start exploring
                  <div class="explain">Unlimited retakes, weekly group coaching, and live job alerts are all on.</div>
                </div>
              </div>
            </div>
          </div>

          <div class="card reviewers">
            <div class="lil-header">From people like you</div>
            <div class="reviews">
              <div class="review">
                <img
                  class="star"
                  :src="ImageStars"
                />
                <div class="comment">
                  “Zanetta helped me get a much higher paying job. She was especially helpful with focusing on what I
                  should pursue and the job interview process. Well worth the money.”
                </div>
                <div class="who">
                  Jaxson
                  <div class="verified">. Verified</div>
                </div>
              </div>
              <div class="review">
                <img
                  class="star"
                  :src="ImageStars"
                />
                <div class="comment">
                  “When I got pregnant, I quit my job and took care of my son for the past 20 years. Now that my son is
                  off to college, I wanted to return to the workforce but didn’t know what to do…”
                </div>
                <div class="who">
                  Hyunmi L.
                  <div class="verified">. Verified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iFooter />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import { useRouter } from "vue-router"
import { breakpointLg, breakpointMd } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"
import { GlobalVariables } from "@/helpers/globalVariables"
import GtmService, { UserFlow } from "@/services/gtmService"

// Components
import iStripeEmbeddedForm from "@/components/global/StripeEmbeddedForm.vue"
import iFooter from "@/components/welcome/Footer.vue"

// ASSETS
import logoDark from "@/assets/logo/logo-dark.svg"
import iconChevron from "@/assets/icons/icon-chevron-left-blue.svg"
import iconSecure from "@/assets/icons/icon-secure-1.svg"
import iconGuarantee from "@/assets/icons/icon-guarantee-1.svg"
import iconSupport from "@/assets/icons/icon-support-1.svg"
import iconCheckBlue from "@/assets/icons/icon-check-blue.svg"
import iconCheckCyan from "@/assets/icons/icon-check-cyan.svg"
import iconCheckPink from "@/assets/icons/icon-check-pink.svg"
import ImageStars from "@/assets/icons/icon-five-orange-stars.svg"

// TYPES
import StripePrice from "@/shared/enums/StripePrice"

// ROUTERS
const router = useRouter()
const stripePrice = router.currentRoute.value.query.uuid as StripePrice

// COMPOSABLES
const isDesktopOrLarger = useIsScreenSize(breakpointLg)
const isTabletOrLarger = useIsScreenSize(breakpointMd)

// CONSTANTS
const PLANS: { [key: string]: any } = {
  [StripePrice.REPORT_MONTHLY]: {
    type: "Monthly",
    price: "$29.99",
    perDay: "$0.99",
    icon: iconCheckCyan,
    timeline: "monthly"
  },
  [StripePrice.REPORT_QUARTERLY]: {
    type: "Quarterly",
    price: "$19.99",
    perDay: "$0.66",
    icon: iconCheckPink,
    timeline: "quarterly"
  },
  [StripePrice.REPORT_ANNUAL]: {
    type: "Annual",
    price: "$9.99",
    perDay: "$0.33",
    icon: iconCheckBlue,
    timeline: "yearly"
  }
}

// FUNCTIONS
function onStripeError() {
  // Go back to the previous page if there is an error with the Stripe form
  router.go(-1)
}

const goToPaywall = () => {
  router.push({ name: GlobalVariables.urls.discover.routeName })
}

// Lifecycle
onMounted(async () => {
  await GtmService.addToCartEvent(UserFlow.REPORT)

  scrollTo({ top: 0, behavior: "instant" })
})
</script>

<style scoped lang="scss">
.i-report-checkout {
  @include flex(column, start, center);

  min-height: 100vh;

  .logo-bar {
    @include flex(row, start, center);

    width: 100%;
    height: 50px;
    padding: 15px 45px;
    background-color: $white;

    @media screen and (min-width: $breakpoint-md) {
      height: 60px;
    }

    .logo {
      height: 28px;
    }
  }

  .content {
    @include flex(column, start, start, $gap: 10px);

    width: 100%;
    padding: 15px 45px;

    @media screen and (min-width: $breakpoint-md) {
      padding: 15px 110px;
    }

    .back {
      @include flex(row, start, center, $gap: 4px);
      @include text-sm;

      cursor: pointer;

      .chevron {
        height: 8px;
      }
    }

    .intro {
      @include display-sm;

      margin-top: 10px;
      font-weight: 700;
      max-width: 590px;

      @media screen and (min-width: $breakpoint-md) {
        @include display-md;
      }

      span {
        font-weight: 500;
        background-image: linear-gradient(90deg, #673cfc 0%, #be4fff 100%);
        color: transparent;
        background-clip: text;
      }

      .sub {
        @include text-lg;

        margin-top: 5px;
        color: $comet700;
        font-weight: 300;
        font-style: italic;

        @media screen and (min-width: $breakpoint-md) {
          @include text-xl;
        }
      }
    }

    .points {
      @include flex(column, center, stretch, $gap: 15px);

      font-weight: 300;
      width: 100%;
      padding: 15px 0;

      @media screen and (min-width: $breakpoint-xxs) {
        @include flex(row, center, stretch, $gap: 10px);
      }

      @media screen and (min-width: $breakpoint-xs) {
        gap: 25px;
      }

      @media screen and (min-width: $breakpoint-md) {
        gap: 15px;
      }

      .point {
        @include flex(column, center, center, $gap: 8px);
        @include border-radius-md;

        font-weight: 600;
        background-color: $white;
        box-shadow: 0 4px 16px 0 $black100;
        padding: 14px 18px;

        @media screen and (min-width: $breakpoint-lg) {
          @include flex(row, start, center, $gap: 12px);
        }

        .text {
          @include flex(column, start, center);
          @include text-sm;

          text-align: center;

          @media screen and (min-width: $breakpoint-md) {
            @include text-md;
          }

          @media screen and (min-width: $breakpoint-lg) {
            align-items: start;
          }

          span {
            @include text-xs;

            font-weight: 300;
          }
        }
      }
    }

    .main {
      @include flex(column, start, center, $gap: 35px);

      width: 100%;
      max-width: 1400px;
      margin: auto;

      @media screen and (min-width: $breakpoint-lg) {
        @include flex(row, start, start, $gap: 35px);
      }

      .left,
      .small {
        @include flex(column, start, stretch, $gap: 30px);

        width: 100%;

        @media screen and (min-width: $breakpoint-lg) {
          width: 50%;
        }

        .lil-header {
          @include text-xs;

          color: $comet700;
          text-transform: uppercase;
          font-weight: 700;
        }

        .card {
          @include border-radius-lg;

          color: $astronaut950;
          border: 1px solid $zumthor100;
          padding: 20px;
          box-shadow: 0 4px 16px 0 $black100;
        }

        .plan {
          @include flex(column, start, start, $gap: 18px);

          .title {
            @include flex(column, start, start);
            @include text-lg;

            font-weight: 600;

            span {
              @include text-sm;

              color: $comet500;
              font-weight: 400;
            }
          }

          .price {
            @include flex(column, start, start, $gap: 2px);

            .total {
              @include display-sm;

              font-weight: 800;

              .timeline {
                @include text-sm;

                color: $comet500;
                font-weight: 400;
              }
            }

            .day {
              @include text-sm;

              font-weight: 400;
            }

            .grey {
              @include text-xs;

              color: $comet400;
              font-weight: 400;
            }
          }

          .perks {
            @include flex(column, start, start, $gap: 8px);
            @include text-sm;

            @media screen and (min-width: $breakpoint-sm) {
              @include text-md;

              gap: 8px;
            }

            .item {
              @include flex(row, start, center, $gap: 5px);
            }

            img {
              width: 18px;
              height: 18px;
            }
          }
        }

        .next {
          @include flex(column, start, stretch, $gap: 15px);

          .tips {
            @include flex(column, start, start, $gap: 15px);

            .tip {
              @include flex(row, start, start, $gap: 8px);

              .number {
                @include flex(row, center, center);
                @include border-radius-rounded;
                @include text-sm;

                font-weight: 700;
                color: $white;
                background-color: $black;
                width: 28px;
                height: 28px;
                flex: 28px 0 0;
              }

              .do {
                @include flex(column, start, start, $gap: 1px);
                @include text-md;

                font-weight: 600;

                .explain {
                  @include text-sm;

                  color: $comet500;
                  font-weight: 400;
                }
              }
            }
          }
        }

        .reviewers {
          @include flex(column, start, stretch, $gap: 15px);

          .reviews {
            @include flex(column, start, stretch);

            .review {
              @include flex(column, start, stretch, $gap: 4px);

              &:nth-child(1) {
                border-bottom: 1px solid $zumthor100;
                padding-bottom: 10px;
              }

              &:nth-child(2) {
                padding-top: 10px;
              }

              .star {
                width: 83px;
              }

              .comment {
                @include text-sm;
              }

              .who {
                @include flex(row, start, center, $gap: 4px);
                @include text-xs;

                font-weight: 600;

                .verified {
                  color: $comet400;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }

      .right {
        width: 100%;

        @media screen and (min-width: $breakpoint-lg) {
          width: 50%;
        }
      }

      #embedded-form {
        @include border-radius-lg;

        border: 1px solid $zumthor100;
        padding-bottom: 15px;
        background-color: #f8f8f8;
        overflow: clip;
        width: 100%;
        box-shadow: 0 4px 16px 0 $black100;
      }
    }
  }
}
</style>
